module.exports = __webpack_public_path__ + "img/提案审批.224247d7.png";